import React from 'react';
import ReportsShows from '../components/Reports/ReportsShows';
import '../components/LiveIntel/liveIntel.css';
import '../components/Reports/reports.css';

const ReportsShowsPage = () => <ReportsShows />;

export default ReportsShowsPage;
